import React from "react";
import { Link } from "react-router-dom";

export function Brand() {
  return (
    <Link className="brand" to="/" aria-label="StanceKit home">
      STANCEKIT
    </Link>
  );
}
